import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';

@Component({
    selector: 'topo-whatsapp-notification-message-control',
    templateUrl: './whatsapp-notification-message-control.component.html',
    styleUrls: ['./whatsapp-notification-message-control.component.scss'],
    standalone: false
})
export class WhatsappNotificationMessageControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() set messageSettings(value: MessageSettings) {
    this._messageSettings = value;
    this.loadData();
  }
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    this.loadData();
  }
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  _messageSettings: MessageSettings;
  _culture: string;
  editMode: boolean;
  useCustomText: boolean;
  messageText: string;

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    this.loadData();
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;
    this.loadData();
  }

  private loadData(): void {
    this.messageText = this.templateDesignerService.getTranslateText(this._messageSettings?.smsNotificationMessage, this._culture);
  }

  edit(): void {}

  setRuntimeData(data: any): void {}
}
